import Joi from "joi";

export const applyForOrderValidator = Joi.object({
    application_price: Joi.number().required().messages({
        'number.base': 'Заповніть це поле',
        'number.min': 'price має бути додатнім числом'
    }),
    application_message: Joi.string().required().messages({
        'string.empty': 'Заповніть це поле',
    })
});
